<template>
    <div class="-mx-4 mt-2 h-4 bg-gray-50 sm:hidden" />
    <div class="my-2 hidden justify-center sm:flex">
        <div class="w-5/6 border-t" />
    </div>
</template>
